import { $ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-article-actions]')) return;

  showShareOptions();
}

function showShareOptions() {
  const buttonShare = $('[data-au-article-actions-btn-share]');
  const buttonShareIcon = buttonShare.querySelector('[data-au-icon]');
  const shareActions = $('[data-au-article-actions-share]');

  buttonShare.addEventListener('click', (e) => {
    e.preventDefault();
    if (buttonShareIcon.textContent === 'share') {
      buttonShareIcon.textContent = 'close';
      shareActions.classList.add('au-article-actions__share-container--opened');
    } else {
      buttonShareIcon.textContent = 'share';
      shareActions.classList.remove('au-article-actions__share-container--opened');
    }

    const el = e.currentTarget;
    if (!el.closest('[data-au-article]')) return;
    const titleText = el.closest('[data-au-article]').querySelector('[data-au-title]')
      ? el.closest('[data-au-article]').querySelector('[data-au-title]').innerText
      : '';
    const clickText = el.querySelector(':not([data-au-icon])').innerText;
    const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickIcono',
      item_id,
    });
  });

  document.addEventListener('click', (event) => {
    if (!shareActions.contains(event.target) && event.target !== buttonShare) {
      buttonShareIcon.textContent = 'share';
      shareActions.classList.remove('au-article-actions__share-container--opened');
    }
  });
}

export default { init };
